import { useMemo } from "react";
import { DefaultParams, useLocation, useRouter } from "wouter";

import { decodeParams } from "./decodeParams";

export const useSomeParams = (...routes: string[]): Record<string, string> => {
  const router = useRouter();
  const [path] = useLocation();

  const params = useMemo((): DefaultParams => {
    for (const route of routes) {
      const [, matchingParams] = router.matcher(route, path);
      if (matchingParams) {
        return matchingParams;
      }
    }
    return {};
  }, [...routes, path]);

  return decodeParams(params);
};
